import { useOrg } from "../../auth/org-provider";
import { useQuery } from "@tanstack/react-query";
import _ from "lodash";
import { apiClient } from "../service/tekkr-service";
import { isProjectStarted } from "../../lib/projects/utils";

export function useProjectsListQuery() {
    const org = useOrg();
    return useQuery({
        queryKey: ["project-list", org.id],
        queryFn: async () => {
            const res = await apiClient.listProjects();
            if (res.status !== 200) {
                throw new Error("failed to fetch projects");
            }

            const projectsByStarted = _.groupBy(res.body.data, (p) => (isProjectStarted(p) ? "started" : "upcoming"));
            if (!projectsByStarted["started"]) {
                projectsByStarted["started"] = [];
            }
            if (!projectsByStarted["upcoming"]) {
                projectsByStarted["upcoming"] = [];
            }

            return {
                startedProjects: projectsByStarted["started"],
                upcomingProjects: projectsByStarted["upcoming"],
            };
        },
    });
}
